import { useState, MouseEvent, cloneElement, ReactElement, CSSProperties } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AgTypography from '../../../Styles/AgTypography';
import { AgColor } from '../../../Styles/AgColor';
import AgButton from '../../AgButton';

export interface DropdownOptionProps { //Todo please update interface as need
  name: string;
  icon: ReactElement;
  borderBottom?: boolean;
  borderTop?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

const AgFancyDropdown = (
  {
    options,
    buttonLabel,
    buttonStartIcon,
    buttonEndIcon,
    variant,
    color,
    width,
    style,
    buttonDisabled
  }: {
    options: DropdownOptionProps[];
    buttonLabel?: string;
    buttonStartIcon?: ReactElement;
    buttonEndIcon?: ReactElement;
    variant?: 'text' | 'outlined' | 'contained';
    color?: string;
    width?: string;
    style?: CSSProperties;
    buttonDisabled?: boolean;
  }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AgTypography
      style={{
        display: 'flex',
        gap: '300px'
      }}>

      <AgButton
        onClick={handleClick}
        label={buttonLabel ?? 'AgButton'}
        startIcon={buttonStartIcon}
        endIcon={buttonEndIcon}
        variant={variant}
        width= {width}
        disabled={buttonDisabled}
        style={{
          color: color,
          ...style
        }}
      />

      <Menu
        id='demo-positioned-menu'
        aria-labelledby='demo-positioned-button'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        sx={{
          '& .MuiPaper-root': {
            boxShadow: '0px 1px 2px 0px #0000000D',
            border: `1px solid ${AgColor.grey3}`,
            minWidth: '160px',
            width: '100%',
            maxWidth: '220px',
            borderRadius: '8px',
          },
          '& .MuiMenu-list': {
            padding: '0'
          }
        }}
      >
        {options.length ? options.map(item => {
          return (
            <MenuItem
              disabled={item.disabled}
              onClick={() => {
                item.onClick && item.onClick();
                setAnchorEl(null);
              }}
              style={{
                padding: '0',
                borderBottom: item.borderBottom ? `1px solid ${AgColor.grey3}` : 'none',
                borderTop: item.borderTop ? `1px solid ${AgColor.grey3}` : 'none'
              }}
              sx={{
                '&:hover': {
                  backgroundColor: AgColor.grey0
                }
              }}
            >
              <AgTypography //in general, we have 3 layers  to wrap up the icon as per design on figma
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '16px',
                  width: '160px',
                  color: AgColor.secondaryDark
                }}
                sx={{
                  '&:hover': {
                    color: `${AgColor.secondaryMain} !important` // MUI has style by default, !important is necessary here
                  }
                }}
              >
                <AgTypography
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '16px',
                    height: '16px',
                    color: 'inherit'
                  }}>
                  {cloneElement(item.icon, { style: { fontSize: '16px' } })}
                </AgTypography>
                <AgTypography
                  contentStyle={'AP.Paragraph.Small.Link'}
                  style={{
                    color: 'inherit',
                    fontSize: '12px',
                    lineHeight: '18px',
                    fontFamily: 'Inter',
                    fontWeight: 600
                  }}
                >
                  {item.name}
                </AgTypography>
              </AgTypography>
            </MenuItem>
          );
        }) : null}
      </Menu>
    </AgTypography>
  );
};

export default AgFancyDropdown;